var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCallerTrackerAndroid = function SvgCallerTrackerAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190,
    height: 220,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CallerTrackerAndroid_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M182.001 8h-174v174.001h174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D639",
    d: "M179.618 0H10.286C4.747 0 0 4.715 0 10.215V209c0 6.285 4.747 11 10.286 11h168.54c5.539 0 10.288-4.715 10.288-10.215V10.215c.79-5.5-3.957-10.215-9.496-10.215m2.373 172.856c0 4.716-4.035 9.145-7.991 9.145H15.999c-4.747 0-8.086-5.216-8.086-9.145V15.716c0-4.716 3.957-7.86 7.912-7.86H174.08c4.747 0 7.912 3.929 7.912 7.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.711 204.605q.001-.526-.163-.936a1.86 1.86 0 0 0-.55-.751c-.267-.227-.64-.445-1.127-.655q-.716-.329-1.826-.67a20 20 0 0 1-2.252-.831 8.6 8.6 0 0 1-1.782-1.078 4.65 4.65 0 0 1-1.183-1.418q-.422-.81-.423-1.862.002-1.045.435-1.9a4.4 4.4 0 0 1 1.254-1.476 6 6 0 0 1 1.934-.973q1.113-.352 2.462-.352 1.896 0 3.268.704 1.383.702 2.122 1.887.748 1.182.75 2.613h-2.919q0-.843-.364-1.488-.348-.658-1.078-1.032-.714-.374-1.816-.374-1.043 0-1.733.315-.691.317-1.032.856a2.23 2.23 0 0 0-.34 1.22q0 .479.223.877.223.388.68.726.456.33 1.148.621.692.294 1.628.565 1.418.42 2.474.936 1.053.503 1.758 1.149.703.644 1.053 1.464.352.81.352 1.841 0 1.077-.432 1.946a4.2 4.2 0 0 1-1.242 1.464q-.8.596-1.924.926-1.112.316-2.483.316-1.231 0-2.425-.328a7.2 7.2 0 0 1-2.156-.997 5.1 5.1 0 0 1-1.548-1.687q-.574-1.021-.574-2.378h2.94q.002.83.282 1.417.292.587.809.961.517.364 1.195.538.692.176 1.477.176 1.029 0 1.723-.291.703-.294 1.053-.821.352-.528.352-1.22m10.453 2.381q.692 0 1.242-.272a2.34 2.34 0 0 0 .904-.772q.351-.492.386-1.137h2.66a3.96 3.96 0 0 1-.726 2.239 5.1 5.1 0 0 1-1.863 1.604q-1.162.587-2.566.587-1.455 0-2.533-.492a5 5 0 0 1-1.792-1.383 6.1 6.1 0 0 1-1.078-2.027 8.4 8.4 0 0 1-.352-2.461v-.411q0-1.311.352-2.462a6.1 6.1 0 0 1 1.078-2.038 4.9 4.9 0 0 1 1.792-1.372q1.08-.502 2.52-.503 1.523 0 2.672.609a4.5 4.5 0 0 1 1.804 1.676q.668 1.067.692 2.484h-2.66a2.86 2.86 0 0 0-.352-1.266 2.3 2.3 0 0 0-.867-.912q-.552-.34-1.323-.34-.857-.001-1.42.35a2.37 2.37 0 0 0-.878.938 4.5 4.5 0 0 0-.457 1.325q-.129.726-.13 1.511v.411q.001.785.13 1.523.13.737.445 1.324.33.574.89.927.564.339 1.43.34m14.508-.528v-6.048q0-.678-.245-1.171a1.72 1.72 0 0 0-.75-.762q-.493-.269-1.242-.269-.693 0-1.195.234a1.94 1.94 0 0 0-.787.633 1.53 1.53 0 0 0-.282.902h-2.81q0-.751.361-1.454a3.9 3.9 0 0 1 1.056-1.254 5.3 5.3 0 0 1 1.652-.865q.962-.319 2.156-.318 1.43 0 2.533.481a3.87 3.87 0 0 1 1.745 1.452q.644.96.643 2.416v5.636q0 .867.117 1.558.132.68.365 1.183V209h-2.895a5 5 0 0 1-.317-1.161 10 10 0 0 1-.105-1.381m.41-5.168.025 1.745h-2.03q-.783.001-1.38.152-.598.142-.998.423a1.8 1.8 0 0 0-.596.679q-.2.4-.2.902 0 .504.234.927.236.411.68.643.457.234 1.102.234.865 0 1.51-.349c.438-.245.783-.535 1.032-.88q.376-.529.399-.997l.914 1.254q-.14.48-.481 1.031a5 5 0 0 1-.89 1.056 4.4 4.4 0 0 1-1.3.809q-.752.316-1.736.316-1.24 0-2.215-.492-.972-.506-1.523-1.349a3.5 3.5 0 0 1-.55-1.934q0-1.009.374-1.779.388-.787 1.125-1.313.75-.528 1.828-.797 1.079-.281 2.462-.281zm8.18-2.263V209h-2.824v-12.679h2.66zm-.504 3.165-.914-.012q.012-1.349.376-2.474a6.1 6.1 0 0 1 1.032-1.933 4.6 4.6 0 0 1 1.593-1.242q.924-.445 2.061-.445.916-.001 1.652.259a3 3 0 0 1 1.279.807q.54.564.819 1.466.281.889.281 2.191V209h-2.836v-8.204q.001-.914-.268-1.439a1.5 1.5 0 0 0-.763-.763q-.492-.235-1.23-.235-.725 0-1.3.306a2.9 2.9 0 0 0-.973.831 4 4 0 0 0-.596 1.22 5 5 0 0 0-.213 1.476m19.863-3.293V209h-2.823v-12.679h2.66zm-.457 3.293-.96-.012q0-1.313.327-2.425.33-1.115.961-1.934a4.2 4.2 0 0 1 1.572-1.278q.948-.458 2.19-.457.87-.001 1.581.259.73.245 1.254.785.54.538.822 1.381.293.846.293 2.041V209h-2.826v-8.204q0-.924-.281-1.452a1.55 1.55 0 0 0-.784-.75q-.504-.235-1.208-.235-.795 0-1.359.306a2.56 2.56 0 0 0-.902.831 3.7 3.7 0 0 0-.516 1.22 6.5 6.5 0 0 0-.164 1.476m7.864-.75-1.325.293q0-1.148.318-2.168a5.5 5.5 0 0 1 .948-1.804 4.5 4.5 0 0 1 1.56-1.232q.924-.445 2.119-.445c.651 0 1.227.09 1.736.269q.774.26 1.313.821.54.562.818 1.464.283.891.282 2.156V209h-2.836v-8.213q0-.965-.281-1.489a1.47 1.47 0 0 0-.773-.729q-.504-.21-1.207-.21-.656 0-1.161.247a2.3 2.3 0 0 0-.831.667 3 3 0 0 0-.516.973q-.165.55-.164 1.196m16.265 7.793q-1.404 0-2.542-.458a5.6 5.6 0 0 1-1.921-1.3 5.7 5.7 0 0 1-1.208-1.958 6.9 6.9 0 0 1-.423-2.425v-.469q0-1.489.436-2.694.431-1.21 1.205-2.063a5.2 5.2 0 0 1 1.828-1.325 5.7 5.7 0 0 1 2.286-.457q1.36-.001 2.378.457 1.02.457 1.687 1.288.68.821 1.009 1.958.341 1.137.34 2.508v1.208h-9.797v-2.029h7.008v-.223a4 4 0 0 0-.306-1.43 2.43 2.43 0 0 0-.831-1.078q-.563-.409-1.501-.408-.703 0-1.254.303-.539.294-.902.856a4.5 4.5 0 0 0-.562 1.359 7.7 7.7 0 0 0-.188 1.77v.469q.001.833.222 1.547.236.703.68 1.23.447.527 1.078.831.635.293 1.442.293 1.02 0 1.816-.408a4.2 4.2 0 0 0 1.384-1.161l1.489 1.442q-.412.595-1.066 1.147-.657.538-1.606.88-.938.34-2.181.34m10.536-17.297-.281 12.034h-2.415l-.294-12.034zm-3.07 15.727q0-.645.42-1.078.437-.447 1.196-.447.75 0 1.185.447.433.433.433 1.078 0 .62-.433 1.066-.435.433-1.185.433-.76 0-1.196-.433a1.5 1.5 0 0 1-.42-1.066"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M82.562 26.187c1.708 0 3.092-1.34 3.092-2.99s-1.384-2.989-3.093-2.989c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99M113.471 26.187c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.989-3.092-2.989-3.09 1.34-3.09 2.99 1.383 2.99 3.09 2.99M70.197 32.164c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.989-3.092-2.989c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M76.379 32.164c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.989-3.092-2.989c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M82.562 32.164c1.708 0 3.092-1.34 3.092-2.99s-1.384-2.989-3.093-2.989c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99M101.107 32.164c1.709 0 3.093-1.34 3.093-2.99s-1.384-2.989-3.093-2.989c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M107.289 32.164c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.989-3.092-2.989c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99M119.653 32.164c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.989-3.092-2.989-3.09 1.34-3.09 2.99 1.384 2.99 3.09 2.99M70.197 38.14c1.709 0 3.092-1.337 3.092-2.987 0-1.652-1.383-2.99-3.092-2.99-1.706 0-3.09 1.338-3.09 2.99 0 1.65 1.384 2.988 3.09 2.988M113.471 38.14c1.706 0 3.092-1.337 3.092-2.987 0-1.652-1.386-2.99-3.092-2.99s-3.09 1.338-3.09 2.99c0 1.65 1.383 2.988 3.09 2.988"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M119.653 38.14c1.706 0 3.092-1.337 3.092-2.987 0-1.652-1.386-2.99-3.092-2.99s-3.09 1.338-3.09 2.99c0 1.65 1.384 2.988 3.09 2.988M76.379 44.12c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.99-3.092-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99M94.926 44.12c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.99-3.092-2.99-3.09 1.34-3.09 2.99 1.383 2.99 3.09 2.99M113.471 44.12c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.99-3.092-2.99-3.09 1.34-3.09 2.99 1.383 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M119.653 44.12c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.99-3.092-2.99-3.09 1.34-3.09 2.99 1.384 2.99 3.09 2.99M70.197 50.096c1.709 0 3.092-1.337 3.092-2.99 0-1.65-1.383-2.986-3.092-2.986-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.99 3.09 2.99M76.379 50.096c1.709 0 3.092-1.337 3.092-2.99 0-1.65-1.383-2.986-3.092-2.986-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M82.562 50.096c1.708 0 3.092-1.337 3.092-2.99 0-1.65-1.384-2.986-3.093-2.986-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.99 3.09 2.99M94.926 50.096c1.706 0 3.092-1.337 3.092-2.99 0-1.65-1.386-2.986-3.092-2.986s-3.09 1.337-3.09 2.987c0 1.652 1.383 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M101.107 50.096c1.709 0 3.093-1.337 3.093-2.99 0-1.65-1.384-2.986-3.093-2.986-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M107.289 50.096c1.709 0 3.092-1.337 3.092-2.99 0-1.65-1.383-2.986-3.092-2.986-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.99 3.09 2.99M119.653 50.096c1.706 0 3.092-1.337 3.092-2.99 0-1.65-1.386-2.986-3.092-2.986s-3.09 1.337-3.09 2.987c0 1.652 1.384 2.99 3.09 2.99M70.197 56.073c1.709 0 3.092-1.337 3.092-2.987 0-1.652-1.383-2.99-3.092-2.99-1.706 0-3.09 1.338-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M82.562 56.073c1.708 0 3.092-1.337 3.092-2.987 0-1.652-1.384-2.99-3.093-2.99-1.706 0-3.09 1.338-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M94.926 56.073c1.706 0 3.092-1.337 3.092-2.987 0-1.652-1.386-2.99-3.092-2.99s-3.09 1.338-3.09 2.99c0 1.65 1.383 2.987 3.09 2.987M113.471 56.073c1.706 0 3.092-1.337 3.092-2.987 0-1.652-1.386-2.99-3.092-2.99s-3.09 1.338-3.09 2.99c0 1.65 1.383 2.987 3.09 2.987M70.197 62.052c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.989-3.092-2.989c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99M82.562 62.052c1.708 0 3.092-1.34 3.092-2.99s-1.384-2.989-3.093-2.989c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99M94.926 62.052c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.989-3.092-2.989-3.09 1.34-3.09 2.99 1.383 2.99 3.09 2.99M107.289 62.052c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.989-3.092-2.989c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99M119.653 62.052c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.989-3.092-2.989-3.09 1.34-3.09 2.99 1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M70.197 68.029c1.709 0 3.092-1.337 3.092-2.99 0-1.65-1.383-2.987-3.092-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.653 1.384 2.99 3.09 2.99M82.562 68.029c1.708 0 3.092-1.337 3.092-2.99 0-1.65-1.384-2.987-3.093-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.653 1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M88.743 68.029c1.709 0 3.092-1.337 3.092-2.99 0-1.65-1.383-2.987-3.092-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.653 1.384 2.99 3.09 2.99M20.744 74.006c1.706 0 3.09-1.338 3.09-2.988s-1.384-2.99-3.09-2.99c-1.71 0-3.093 1.34-3.093 2.99s1.384 2.987 3.093 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M26.925 74.006c1.706 0 3.09-1.338 3.09-2.988s-1.384-2.99-3.09-2.99c-1.708 0-3.092 1.34-3.092 2.99s1.384 2.987 3.092 2.987M39.29 74.006c1.706 0 3.09-1.338 3.09-2.988s-1.384-2.99-3.09-2.99c-1.71 0-3.093 1.34-3.093 2.99s1.384 2.987 3.092 2.987M57.835 74.006c1.707 0 3.09-1.338 3.09-2.988s-1.383-2.99-3.09-2.99c-1.708 0-3.092 1.34-3.092 2.99s1.384 2.987 3.092 2.987M64.016 74.006c1.708 0 3.092-1.338 3.092-2.988s-1.384-2.99-3.092-2.99c-1.707 0-3.09 1.34-3.09 2.99s1.383 2.987 3.09 2.987M88.743 74.006c1.709 0 3.092-1.338 3.092-2.988s-1.383-2.99-3.092-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.987 3.09 2.987M94.926 74.006c1.706 0 3.092-1.338 3.092-2.988s-1.386-2.99-3.092-2.99-3.09 1.34-3.09 2.99 1.383 2.987 3.09 2.987M107.289 74.006c1.709 0 3.092-1.338 3.092-2.988s-1.383-2.99-3.092-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.987 3.09 2.987M119.653 74.006c1.706 0 3.092-1.338 3.092-2.988s-1.386-2.99-3.092-2.99-3.09 1.34-3.09 2.99 1.384 2.987 3.09 2.987M132.017 74.006c1.706 0 3.09-1.338 3.09-2.988s-1.384-2.99-3.09-2.99-3.092 1.34-3.092 2.99 1.386 2.987 3.092 2.987M138.199 74.006c1.706 0 3.09-1.338 3.09-2.988s-1.384-2.99-3.09-2.99-3.09 1.34-3.09 2.99 1.384 2.987 3.09 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M144.381 74.006c1.707 0 3.09-1.338 3.09-2.988s-1.383-2.99-3.09-2.99c-1.708 0-3.092 1.34-3.092 2.99s1.384 2.987 3.092 2.987M156.745 74.006c1.706 0 3.089-1.338 3.089-2.988s-1.383-2.99-3.089-2.99c-1.707 0-3.093 1.34-3.093 2.99s1.386 2.987 3.093 2.987M162.927 74.006c1.706 0 3.09-1.338 3.09-2.988s-1.384-2.99-3.09-2.99c-1.708 0-3.092 1.34-3.092 2.99s1.384 2.987 3.092 2.987M20.744 79.985c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.99-3.09-2.99c-1.71 0-3.093 1.34-3.093 2.99s1.384 2.99 3.093 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M26.925 79.985c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.99-3.09-2.99c-1.708 0-3.092 1.34-3.092 2.99s1.384 2.99 3.092 2.99M33.108 79.985c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.99-3.09-2.99c-1.709 0-3.092 1.34-3.092 2.99s1.383 2.99 3.092 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M39.29 79.985c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.99-3.09-2.99c-1.71 0-3.093 1.34-3.093 2.99s1.384 2.99 3.092 2.99M64.016 79.985c1.708 0 3.092-1.34 3.092-2.99s-1.384-2.99-3.092-2.99c-1.707 0-3.09 1.34-3.09 2.99s1.383 2.99 3.09 2.99M76.379 79.985c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.99-3.092-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99M88.743 79.985c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.99-3.092-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99M94.926 79.985c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.99-3.092-2.99-3.09 1.34-3.09 2.99 1.383 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M101.107 79.985c1.709 0 3.093-1.34 3.093-2.99s-1.384-2.99-3.093-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99M113.471 79.985c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.99-3.092-2.99-3.09 1.34-3.09 2.99 1.383 2.99 3.09 2.99M119.653 79.985c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.99-3.092-2.99-3.09 1.34-3.09 2.99 1.384 2.99 3.09 2.99M132.017 79.985c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.99-3.09-2.99-3.092 1.34-3.092 2.99 1.386 2.99 3.092 2.99M144.381 79.985c1.707 0 3.09-1.34 3.09-2.99s-1.383-2.99-3.09-2.99c-1.708 0-3.092 1.34-3.092 2.99s1.384 2.99 3.092 2.99M162.927 79.985c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.99-3.09-2.99c-1.708 0-3.092 1.34-3.092 2.99s1.384 2.99 3.092 2.99M20.744 85.961c1.706 0 3.09-1.337 3.09-2.987 0-1.652-1.384-2.99-3.09-2.99-1.71 0-3.093 1.338-3.093 2.99 0 1.65 1.384 2.987 3.093 2.987M33.108 85.961c1.706 0 3.09-1.337 3.09-2.987 0-1.652-1.384-2.99-3.09-2.99-1.709 0-3.092 1.338-3.092 2.99 0 1.65 1.383 2.987 3.092 2.987M45.469 85.961c1.708 0 3.092-1.337 3.092-2.987 0-1.652-1.384-2.99-3.092-2.99-1.706 0-3.09 1.338-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M57.835 85.961c1.707 0 3.09-1.337 3.09-2.987 0-1.652-1.383-2.99-3.09-2.99-1.708 0-3.092 1.338-3.092 2.99 0 1.65 1.384 2.987 3.092 2.987M64.016 85.961c1.708 0 3.092-1.337 3.092-2.987 0-1.652-1.384-2.99-3.092-2.99-1.707 0-3.09 1.338-3.09 2.99 0 1.65 1.383 2.987 3.09 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M70.197 85.961c1.709 0 3.092-1.337 3.092-2.987 0-1.652-1.383-2.99-3.092-2.99-1.706 0-3.09 1.338-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M88.743 85.961c1.709 0 3.092-1.337 3.092-2.987 0-1.652-1.383-2.99-3.092-2.99-1.706 0-3.09 1.338-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M94.926 85.961c1.706 0 3.092-1.337 3.092-2.987 0-1.652-1.386-2.99-3.092-2.99s-3.09 1.338-3.09 2.99c0 1.65 1.383 2.987 3.09 2.987M125.836 85.961c1.709 0 3.092-1.337 3.092-2.987 0-1.652-1.383-2.99-3.092-2.99-1.706 0-3.09 1.338-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M132.017 85.961c1.706 0 3.09-1.337 3.09-2.987 0-1.652-1.384-2.99-3.09-2.99s-3.092 1.338-3.092 2.99c0 1.65 1.386 2.987 3.092 2.987M138.199 85.961c1.706 0 3.09-1.337 3.09-2.987 0-1.652-1.384-2.99-3.09-2.99s-3.09 1.338-3.09 2.99c0 1.65 1.384 2.987 3.09 2.987M150.563 85.961c1.706 0 3.09-1.337 3.09-2.987 0-1.652-1.384-2.99-3.09-2.99s-3.092 1.338-3.092 2.99c0 1.65 1.386 2.987 3.092 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M156.745 85.961c1.706 0 3.089-1.337 3.089-2.987 0-1.652-1.383-2.99-3.089-2.99-1.707 0-3.093 1.338-3.093 2.99 0 1.65 1.386 2.987 3.093 2.987M39.29 91.94c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.989-3.09-2.989c-1.71 0-3.093 1.34-3.093 2.99s1.384 2.99 3.092 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M45.469 91.94c1.708 0 3.092-1.34 3.092-2.99s-1.384-2.989-3.092-2.989c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99M76.379 91.94c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.989-3.092-2.989c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M82.562 91.94c1.708 0 3.092-1.34 3.092-2.99s-1.384-2.989-3.093-2.989c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M88.743 91.94c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.989-3.092-2.989c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99M94.926 91.94c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.989-3.092-2.989-3.09 1.34-3.09 2.99 1.383 2.99 3.09 2.99M119.653 91.94c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.989-3.092-2.989-3.09 1.34-3.09 2.99 1.384 2.99 3.09 2.99M125.836 91.94c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.989-3.092-2.989c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M132.017 91.94c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.989-3.09-2.989-3.092 1.34-3.092 2.99 1.386 2.99 3.092 2.99M138.199 91.94c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.989-3.09-2.989-3.09 1.34-3.09 2.99 1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M144.381 91.94c1.707 0 3.09-1.34 3.09-2.99s-1.383-2.989-3.09-2.989c-1.708 0-3.092 1.34-3.092 2.99s1.384 2.99 3.092 2.99M169.109 91.94c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.989-3.09-2.989c-1.709 0-3.092 1.34-3.092 2.99s1.383 2.99 3.092 2.99M26.925 97.917c1.706 0 3.09-1.337 3.09-2.99 0-1.65-1.384-2.986-3.09-2.986-1.708 0-3.092 1.337-3.092 2.987 0 1.652 1.384 2.99 3.092 2.99M51.651 97.917c1.709 0 3.092-1.337 3.092-2.99 0-1.65-1.383-2.986-3.092-2.986-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M57.835 97.917c1.707 0 3.09-1.337 3.09-2.99 0-1.65-1.383-2.986-3.09-2.986-1.708 0-3.092 1.337-3.092 2.987 0 1.652 1.384 2.99 3.092 2.99M70.197 97.917c1.709 0 3.092-1.337 3.092-2.99 0-1.65-1.383-2.986-3.092-2.986-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.99 3.09 2.99M82.562 97.917c1.708 0 3.092-1.337 3.092-2.99 0-1.65-1.384-2.986-3.093-2.986-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M88.743 97.917c1.709 0 3.092-1.337 3.092-2.99 0-1.65-1.383-2.986-3.092-2.986-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.99 3.09 2.99M107.289 97.917c1.709 0 3.092-1.337 3.092-2.99 0-1.65-1.383-2.986-3.092-2.986-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.99 3.09 2.99M119.653 97.917c1.706 0 3.092-1.337 3.092-2.99 0-1.65-1.386-2.986-3.092-2.986s-3.09 1.337-3.09 2.987c0 1.652 1.384 2.99 3.09 2.99M132.017 97.917c1.706 0 3.09-1.337 3.09-2.99 0-1.65-1.384-2.986-3.09-2.986s-3.092 1.337-3.092 2.987c0 1.652 1.386 2.99 3.092 2.99M138.199 97.917c1.706 0 3.09-1.337 3.09-2.99 0-1.65-1.384-2.986-3.09-2.986s-3.09 1.337-3.09 2.987c0 1.652 1.384 2.99 3.09 2.99M156.745 97.917c1.706 0 3.089-1.337 3.089-2.99 0-1.65-1.383-2.986-3.089-2.986-1.707 0-3.093 1.337-3.093 2.987 0 1.652 1.386 2.99 3.093 2.99M162.927 97.917c1.706 0 3.09-1.337 3.09-2.99 0-1.65-1.384-2.986-3.09-2.986-1.708 0-3.092 1.337-3.092 2.987 0 1.652 1.384 2.99 3.092 2.99M169.109 97.917c1.706 0 3.09-1.337 3.09-2.99 0-1.65-1.384-2.986-3.09-2.986-1.709 0-3.092 1.337-3.092 2.987 0 1.652 1.383 2.99 3.092 2.99M26.925 103.894c1.706 0 3.09-1.337 3.09-2.987 0-1.653-1.384-2.99-3.09-2.99-1.708 0-3.092 1.337-3.092 2.99 0 1.65 1.384 2.987 3.092 2.987M33.108 103.894c1.706 0 3.09-1.337 3.09-2.987 0-1.653-1.384-2.99-3.09-2.99-1.709 0-3.092 1.337-3.092 2.99 0 1.65 1.383 2.987 3.092 2.987M45.469 103.894c1.708 0 3.092-1.337 3.092-2.987 0-1.653-1.384-2.99-3.092-2.99-1.706 0-3.09 1.337-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M70.197 103.894c1.709 0 3.092-1.337 3.092-2.987 0-1.653-1.383-2.99-3.092-2.99-1.706 0-3.09 1.337-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M76.379 103.894c1.709 0 3.092-1.337 3.092-2.987 0-1.653-1.383-2.99-3.092-2.99-1.706 0-3.09 1.337-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M88.743 103.894c1.709 0 3.092-1.337 3.092-2.987 0-1.653-1.383-2.99-3.092-2.99-1.706 0-3.09 1.337-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M107.289 103.894c1.709 0 3.092-1.337 3.092-2.987 0-1.653-1.383-2.99-3.092-2.99-1.706 0-3.09 1.337-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M138.199 103.894c1.706 0 3.09-1.337 3.09-2.987 0-1.653-1.384-2.99-3.09-2.99s-3.09 1.337-3.09 2.99c0 1.65 1.384 2.987 3.09 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M144.381 103.894c1.707 0 3.09-1.337 3.09-2.987 0-1.653-1.383-2.99-3.09-2.99-1.708 0-3.092 1.337-3.092 2.99 0 1.65 1.384 2.987 3.092 2.987M156.745 103.894c1.706 0 3.089-1.337 3.089-2.987 0-1.653-1.383-2.99-3.089-2.99-1.707 0-3.093 1.337-3.093 2.99 0 1.65 1.386 2.987 3.093 2.987M162.927 103.894c1.706 0 3.09-1.337 3.09-2.987 0-1.653-1.384-2.99-3.09-2.99-1.708 0-3.092 1.337-3.092 2.99 0 1.65 1.384 2.987 3.092 2.987M169.109 103.894c1.706 0 3.09-1.337 3.09-2.987 0-1.653-1.384-2.99-3.09-2.99-1.709 0-3.092 1.337-3.092 2.99 0 1.65 1.383 2.987 3.092 2.987M20.744 109.873c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.989-3.09-2.989c-1.71 0-3.093 1.339-3.093 2.989s1.384 2.99 3.093 2.99M39.29 109.873c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.989-3.09-2.989c-1.71 0-3.093 1.339-3.093 2.989s1.384 2.99 3.092 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M45.469 109.873c1.708 0 3.092-1.34 3.092-2.99s-1.384-2.989-3.092-2.989c-1.706 0-3.09 1.339-3.09 2.989s1.384 2.99 3.09 2.99M57.835 109.873c1.707 0 3.09-1.34 3.09-2.99s-1.383-2.989-3.09-2.989c-1.708 0-3.092 1.339-3.092 2.989s1.384 2.99 3.092 2.99M64.016 109.873c1.708 0 3.092-1.34 3.092-2.99s-1.384-2.989-3.092-2.989c-1.707 0-3.09 1.339-3.09 2.989s1.383 2.99 3.09 2.99M88.743 109.873c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.989-3.092-2.989c-1.706 0-3.09 1.339-3.09 2.989s1.384 2.99 3.09 2.99M107.289 109.873c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.989-3.092-2.989c-1.706 0-3.09 1.339-3.09 2.989s1.384 2.99 3.09 2.99M113.471 109.873c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.989-3.092-2.989-3.09 1.339-3.09 2.989 1.383 2.99 3.09 2.99M119.653 109.873c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.989-3.092-2.989-3.09 1.339-3.09 2.989 1.384 2.99 3.09 2.99M132.017 109.873c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.989-3.09-2.989-3.092 1.339-3.092 2.989 1.386 2.99 3.092 2.99M144.381 109.873c1.707 0 3.09-1.34 3.09-2.99s-1.383-2.989-3.09-2.989c-1.708 0-3.092 1.339-3.092 2.989s1.384 2.99 3.092 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M150.563 109.873c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.989-3.09-2.989-3.092 1.339-3.092 2.989 1.386 2.99 3.092 2.99M169.109 109.873c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.989-3.09-2.989c-1.709 0-3.092 1.339-3.092 2.989s1.383 2.99 3.092 2.99M26.925 115.85c1.706 0 3.09-1.338 3.09-2.99 0-1.65-1.384-2.987-3.09-2.987-1.708 0-3.092 1.337-3.092 2.987 0 1.652 1.384 2.99 3.092 2.99M64.016 115.85c1.708 0 3.092-1.338 3.092-2.99 0-1.65-1.384-2.987-3.092-2.987-1.707 0-3.09 1.337-3.09 2.987 0 1.652 1.383 2.99 3.09 2.99M76.379 115.85c1.709 0 3.092-1.338 3.092-2.99 0-1.65-1.383-2.987-3.092-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.99 3.09 2.99M88.743 115.85c1.709 0 3.092-1.338 3.092-2.99 0-1.65-1.383-2.987-3.092-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.99 3.09 2.99M132.017 115.85c1.706 0 3.09-1.338 3.09-2.99 0-1.65-1.384-2.987-3.09-2.987s-3.092 1.337-3.092 2.987c0 1.652 1.386 2.99 3.092 2.99M138.199 115.85c1.706 0 3.09-1.338 3.09-2.99 0-1.65-1.384-2.987-3.09-2.987s-3.09 1.337-3.09 2.987c0 1.652 1.384 2.99 3.09 2.99M20.744 121.826c1.706 0 3.09-1.337 3.09-2.987 0-1.652-1.384-2.99-3.09-2.99-1.71 0-3.093 1.338-3.093 2.99 0 1.65 1.384 2.987 3.093 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M26.925 121.826c1.706 0 3.09-1.337 3.09-2.987 0-1.652-1.384-2.99-3.09-2.99-1.708 0-3.092 1.338-3.092 2.99 0 1.65 1.384 2.987 3.092 2.987M33.108 121.826c1.706 0 3.09-1.337 3.09-2.987 0-1.652-1.384-2.99-3.09-2.99-1.709 0-3.092 1.338-3.092 2.99 0 1.65 1.383 2.987 3.092 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M39.29 121.826c1.706 0 3.09-1.337 3.09-2.987 0-1.652-1.384-2.99-3.09-2.99-1.71 0-3.093 1.338-3.093 2.99 0 1.65 1.384 2.987 3.092 2.987M57.835 121.826c1.707 0 3.09-1.337 3.09-2.987 0-1.652-1.383-2.99-3.09-2.99-1.708 0-3.092 1.338-3.092 2.99 0 1.65 1.384 2.987 3.092 2.987M64.016 121.826c1.708 0 3.092-1.337 3.092-2.987 0-1.652-1.384-2.99-3.092-2.99-1.707 0-3.09 1.338-3.09 2.99 0 1.65 1.383 2.987 3.09 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M70.197 121.826c1.709 0 3.092-1.337 3.092-2.987 0-1.652-1.383-2.99-3.092-2.99-1.706 0-3.09 1.338-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M76.379 121.826c1.709 0 3.092-1.337 3.092-2.987 0-1.652-1.383-2.99-3.092-2.99-1.706 0-3.09 1.338-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M82.562 121.826c1.708 0 3.092-1.337 3.092-2.987 0-1.652-1.384-2.99-3.093-2.99-1.706 0-3.09 1.338-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M94.926 121.826c1.706 0 3.092-1.337 3.092-2.987 0-1.652-1.386-2.99-3.092-2.99s-3.09 1.338-3.09 2.99c0 1.65 1.383 2.987 3.09 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M101.107 121.826c1.709 0 3.093-1.337 3.093-2.987 0-1.652-1.384-2.99-3.093-2.99-1.706 0-3.09 1.338-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M119.653 121.826c1.706 0 3.092-1.337 3.092-2.987 0-1.652-1.386-2.99-3.092-2.99s-3.09 1.338-3.09 2.99c0 1.65 1.384 2.987 3.09 2.987M125.836 121.826c1.709 0 3.092-1.337 3.092-2.987 0-1.652-1.383-2.99-3.092-2.99-1.706 0-3.09 1.338-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M132.017 121.826c1.706 0 3.09-1.337 3.09-2.987 0-1.652-1.384-2.99-3.09-2.99s-3.092 1.338-3.092 2.99c0 1.65 1.386 2.987 3.092 2.987M138.199 121.826c1.706 0 3.09-1.337 3.09-2.987 0-1.652-1.384-2.99-3.09-2.99s-3.09 1.338-3.09 2.99c0 1.65 1.384 2.987 3.09 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M144.381 121.826c1.707 0 3.09-1.337 3.09-2.987 0-1.652-1.383-2.99-3.09-2.99-1.708 0-3.092 1.338-3.092 2.99 0 1.65 1.384 2.987 3.092 2.987M169.109 121.826c1.706 0 3.09-1.337 3.09-2.987 0-1.652-1.384-2.99-3.09-2.99-1.709 0-3.092 1.338-3.092 2.99 0 1.65 1.383 2.987 3.092 2.987M70.197 127.805c1.709 0 3.092-1.339 3.092-2.989s-1.383-2.99-3.092-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.989 3.09 2.989M76.379 127.805c1.709 0 3.092-1.339 3.092-2.989s-1.383-2.99-3.092-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.989 3.09 2.989"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M82.562 127.805c1.708 0 3.092-1.339 3.092-2.989s-1.384-2.99-3.093-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.989 3.09 2.989M94.926 127.805c1.706 0 3.092-1.339 3.092-2.989s-1.386-2.99-3.092-2.99-3.09 1.34-3.09 2.99 1.383 2.989 3.09 2.989"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M101.107 127.805c1.709 0 3.093-1.339 3.093-2.989s-1.384-2.99-3.093-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.989 3.09 2.989"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M107.289 127.805c1.709 0 3.092-1.339 3.092-2.989s-1.383-2.99-3.092-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.989 3.09 2.989M119.653 127.805c1.706 0 3.092-1.339 3.092-2.989s-1.386-2.99-3.092-2.99-3.09 1.34-3.09 2.99 1.384 2.989 3.09 2.989M144.381 127.805c1.707 0 3.09-1.339 3.09-2.989s-1.383-2.99-3.09-2.99c-1.708 0-3.092 1.34-3.092 2.99s1.384 2.989 3.092 2.989M70.197 133.782c1.709 0 3.092-1.337 3.092-2.99 0-1.65-1.383-2.987-3.092-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.653 1.384 2.99 3.09 2.99M82.562 133.782c1.708 0 3.092-1.337 3.092-2.99 0-1.65-1.384-2.987-3.093-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.653 1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M88.743 133.782c1.709 0 3.092-1.337 3.092-2.99 0-1.65-1.383-2.987-3.092-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.653 1.384 2.99 3.09 2.99M94.926 133.782c1.706 0 3.092-1.337 3.092-2.99 0-1.65-1.386-2.987-3.092-2.987s-3.09 1.337-3.09 2.987c0 1.653 1.383 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M101.107 133.782c1.709 0 3.093-1.337 3.093-2.99 0-1.65-1.384-2.987-3.093-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.653 1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M107.289 133.782c1.709 0 3.092-1.337 3.092-2.99 0-1.65-1.383-2.987-3.092-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.653 1.384 2.99 3.09 2.99M113.471 133.782c1.706 0 3.092-1.337 3.092-2.99 0-1.65-1.386-2.987-3.092-2.987s-3.09 1.337-3.09 2.987c0 1.653 1.383 2.99 3.09 2.99M119.653 133.782c1.706 0 3.092-1.337 3.092-2.99 0-1.65-1.386-2.987-3.092-2.987s-3.09 1.337-3.09 2.987c0 1.653 1.384 2.99 3.09 2.99M132.017 133.782c1.706 0 3.09-1.337 3.09-2.99 0-1.65-1.384-2.987-3.09-2.987s-3.092 1.337-3.092 2.987c0 1.653 1.386 2.99 3.092 2.99M144.381 133.782c1.707 0 3.09-1.337 3.09-2.99 0-1.65-1.383-2.987-3.09-2.987-1.708 0-3.092 1.337-3.092 2.987 0 1.653 1.384 2.99 3.092 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M150.563 133.782c1.706 0 3.09-1.337 3.09-2.99 0-1.65-1.384-2.987-3.09-2.987s-3.092 1.337-3.092 2.987c0 1.653 1.386 2.99 3.092 2.99M162.927 133.782c1.706 0 3.09-1.337 3.09-2.99 0-1.65-1.384-2.987-3.09-2.987-1.708 0-3.092 1.337-3.092 2.987 0 1.653 1.384 2.99 3.092 2.99M169.109 133.782c1.706 0 3.09-1.337 3.09-2.99 0-1.65-1.384-2.987-3.09-2.987-1.709 0-3.092 1.337-3.092 2.987 0 1.653 1.383 2.99 3.092 2.99M94.926 139.759c1.706 0 3.092-1.337 3.092-2.987 0-1.653-1.386-2.99-3.092-2.99s-3.09 1.337-3.09 2.99c0 1.65 1.383 2.987 3.09 2.987M107.289 139.759c1.709 0 3.092-1.337 3.092-2.987 0-1.653-1.383-2.99-3.092-2.99-1.706 0-3.09 1.337-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M119.653 139.759c1.706 0 3.092-1.337 3.092-2.987 0-1.653-1.386-2.99-3.092-2.99s-3.09 1.337-3.09 2.99c0 1.65 1.384 2.987 3.09 2.987M144.381 139.759c1.707 0 3.09-1.337 3.09-2.987 0-1.653-1.383-2.99-3.09-2.99-1.708 0-3.092 1.337-3.092 2.99 0 1.65 1.384 2.987 3.092 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M150.563 139.759c1.706 0 3.09-1.337 3.09-2.987 0-1.653-1.384-2.99-3.09-2.99s-3.092 1.337-3.092 2.99c0 1.65 1.386 2.987 3.092 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M156.745 139.759c1.706 0 3.089-1.337 3.089-2.987 0-1.653-1.383-2.99-3.089-2.99-1.707 0-3.093 1.337-3.093 2.99 0 1.65 1.386 2.987 3.093 2.987M162.927 139.759c1.706 0 3.09-1.337 3.09-2.987 0-1.653-1.384-2.99-3.09-2.99-1.708 0-3.092 1.337-3.092 2.99 0 1.65 1.384 2.987 3.092 2.987M169.109 139.759c1.706 0 3.09-1.337 3.09-2.987 0-1.653-1.384-2.99-3.09-2.99-1.709 0-3.092 1.337-3.092 2.99 0 1.65 1.383 2.987 3.092 2.987M76.379 145.738c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.989-3.092-2.989c-1.706 0-3.09 1.339-3.09 2.989s1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M82.562 145.738c1.708 0 3.092-1.34 3.092-2.99s-1.384-2.989-3.093-2.989c-1.706 0-3.09 1.339-3.09 2.989s1.384 2.99 3.09 2.99M94.926 145.738c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.989-3.092-2.989-3.09 1.339-3.09 2.989 1.383 2.99 3.09 2.99M113.471 145.738c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.989-3.092-2.989-3.09 1.339-3.09 2.989 1.383 2.99 3.09 2.99M119.653 145.738c1.706 0 3.092-1.34 3.092-2.99s-1.386-2.989-3.092-2.989-3.09 1.339-3.09 2.989 1.384 2.99 3.09 2.99M125.836 145.738c1.709 0 3.092-1.34 3.092-2.99s-1.383-2.989-3.092-2.989c-1.706 0-3.09 1.339-3.09 2.989s1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M132.017 145.738c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.989-3.09-2.989-3.092 1.339-3.092 2.989 1.386 2.99 3.092 2.99M138.199 145.738c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.989-3.09-2.989-3.09 1.339-3.09 2.989 1.384 2.99 3.09 2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M144.381 145.738c1.707 0 3.09-1.34 3.09-2.99s-1.383-2.989-3.09-2.989c-1.708 0-3.092 1.339-3.092 2.989s1.384 2.99 3.092 2.99M156.745 145.738c1.706 0 3.089-1.34 3.089-2.99s-1.383-2.989-3.089-2.989c-1.707 0-3.093 1.339-3.093 2.989s1.386 2.99 3.093 2.99M162.927 145.738c1.706 0 3.09-1.34 3.09-2.99s-1.384-2.989-3.09-2.989c-1.708 0-3.092 1.339-3.092 2.989s1.384 2.99 3.092 2.99M70.197 151.714c1.709 0 3.092-1.337 3.092-2.989 0-1.65-1.383-2.987-3.092-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.989 3.09 2.989M82.562 151.714c1.708 0 3.092-1.337 3.092-2.989 0-1.65-1.384-2.987-3.093-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.989 3.09 2.989"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M88.743 151.714c1.709 0 3.092-1.337 3.092-2.989 0-1.65-1.383-2.987-3.092-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.989 3.09 2.989M101.107 151.714c1.709 0 3.093-1.337 3.093-2.989 0-1.65-1.384-2.987-3.093-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.989 3.09 2.989"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M107.289 151.714c1.709 0 3.092-1.337 3.092-2.989 0-1.65-1.383-2.987-3.092-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.989 3.09 2.989M113.471 151.714c1.706 0 3.092-1.337 3.092-2.989 0-1.65-1.386-2.987-3.092-2.987s-3.09 1.337-3.09 2.987c0 1.652 1.383 2.989 3.09 2.989M119.653 151.714c1.706 0 3.092-1.337 3.092-2.989 0-1.65-1.386-2.987-3.092-2.987s-3.09 1.337-3.09 2.987c0 1.652 1.384 2.989 3.09 2.989M125.836 151.714c1.709 0 3.092-1.337 3.092-2.989 0-1.65-1.383-2.987-3.092-2.987-1.706 0-3.09 1.337-3.09 2.987 0 1.652 1.384 2.989 3.09 2.989M138.199 151.714c1.706 0 3.09-1.337 3.09-2.989 0-1.65-1.384-2.987-3.09-2.987s-3.09 1.337-3.09 2.987c0 1.652 1.384 2.989 3.09 2.989"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M144.381 151.714c1.707 0 3.09-1.337 3.09-2.989 0-1.65-1.383-2.987-3.09-2.987-1.708 0-3.092 1.337-3.092 2.987 0 1.652 1.384 2.989 3.092 2.989M76.379 157.691c1.709 0 3.092-1.337 3.092-2.987s-1.383-2.99-3.092-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.987 3.09 2.987M94.926 157.691c1.706 0 3.092-1.337 3.092-2.987s-1.386-2.99-3.092-2.99-3.09 1.34-3.09 2.99 1.383 2.987 3.09 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M101.107 157.691c1.709 0 3.093-1.337 3.093-2.987s-1.384-2.99-3.093-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.987 3.09 2.987M113.471 157.691c1.706 0 3.092-1.337 3.092-2.987s-1.386-2.99-3.092-2.99-3.09 1.34-3.09 2.99 1.383 2.987 3.09 2.987M138.199 157.691c1.706 0 3.09-1.337 3.09-2.987s-1.384-2.99-3.09-2.99-3.09 1.34-3.09 2.99 1.384 2.987 3.09 2.987M150.563 157.691c1.706 0 3.09-1.337 3.09-2.987s-1.384-2.99-3.09-2.99-3.092 1.34-3.092 2.99 1.386 2.987 3.092 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M156.745 157.691c1.706 0 3.089-1.337 3.089-2.987s-1.383-2.99-3.089-2.99c-1.707 0-3.093 1.34-3.093 2.99s1.386 2.987 3.093 2.987M169.109 157.691c1.706 0 3.09-1.337 3.09-2.987s-1.384-2.99-3.09-2.99c-1.709 0-3.092 1.34-3.092 2.99s1.383 2.987 3.092 2.987M70.197 163.67c1.709 0 3.092-1.339 3.092-2.989s-1.383-2.99-3.092-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.989 3.09 2.989M119.653 163.67c1.706 0 3.092-1.339 3.092-2.989s-1.386-2.99-3.092-2.99-3.09 1.34-3.09 2.99 1.384 2.989 3.09 2.989M125.836 163.67c1.709 0 3.092-1.339 3.092-2.989s-1.383-2.99-3.092-2.99c-1.706 0-3.09 1.34-3.09 2.99s1.384 2.989 3.09 2.989M150.563 163.67c1.706 0 3.09-1.339 3.09-2.989s-1.384-2.99-3.09-2.99-3.092 1.34-3.092 2.99 1.386 2.989 3.092 2.989M162.927 163.67c1.706 0 3.09-1.339 3.09-2.989s-1.384-2.99-3.09-2.99c-1.708 0-3.092 1.34-3.092 2.99s1.384 2.989 3.092 2.989"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M169.109 163.67c1.706 0 3.09-1.339 3.09-2.989s-1.384-2.99-3.09-2.99c-1.709 0-3.092 1.34-3.092 2.99s1.383 2.989 3.092 2.989M70.197 169.647c1.709 0 3.092-1.337 3.092-2.987 0-1.653-1.383-2.99-3.092-2.99-1.706 0-3.09 1.337-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M76.379 169.647c1.709 0 3.092-1.337 3.092-2.987 0-1.653-1.383-2.99-3.092-2.99-1.706 0-3.09 1.337-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M82.562 169.647c1.708 0 3.092-1.337 3.092-2.987 0-1.653-1.384-2.99-3.093-2.99-1.706 0-3.09 1.337-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M107.289 169.647c1.709 0 3.092-1.337 3.092-2.987 0-1.653-1.383-2.99-3.092-2.99-1.706 0-3.09 1.337-3.09 2.99 0 1.65 1.384 2.987 3.09 2.987M119.653 169.647c1.706 0 3.092-1.337 3.092-2.987 0-1.653-1.386-2.99-3.092-2.99s-3.09 1.337-3.09 2.99c0 1.65 1.384 2.987 3.09 2.987M144.381 169.647c1.707 0 3.09-1.337 3.09-2.987 0-1.653-1.383-2.99-3.09-2.99-1.708 0-3.092 1.337-3.092 2.99 0 1.65 1.384 2.987 3.092 2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M150.563 169.647c1.706 0 3.09-1.337 3.09-2.987 0-1.653-1.384-2.99-3.09-2.99s-3.092 1.337-3.092 2.99c0 1.65 1.386 2.987 3.092 2.987M162.927 169.647c1.706 0 3.09-1.337 3.09-2.987 0-1.653-1.384-2.99-3.09-2.99-1.708 0-3.092 1.337-3.092 2.99 0 1.65 1.384 2.987 3.092 2.987M169.109 169.647c1.706 0 3.09-1.337 3.09-2.987 0-1.653-1.384-2.99-3.09-2.99-1.709 0-3.092 1.337-3.092 2.99 0 1.65 1.383 2.987 3.092 2.987M47.843 20.208H30.734c-7.226 0-13.083 5.664-13.083 12.65v16.544c0 6.986 5.857 12.65 13.083 12.65h17.109c7.225 0 13.082-5.664 13.082-12.65V32.858c0-6.986-5.856-12.65-13.082-12.65m6.9 26.83c0 4.99-4.184 9.035-9.345 9.035h-12.22c-5.16 0-9.345-4.045-9.345-9.035V35.222c0-4.99 4.185-9.035 9.346-9.035h12.22c5.16 0 9.344 4.046 9.344 9.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A310",
    d: "M48.562 44.675c0 2.994-2.51 5.421-5.608 5.421h-7.33c-3.098 0-5.608-2.427-5.608-5.421v-7.09c0-2.994 2.51-5.421 5.607-5.421h7.331c3.097 0 5.608 2.427 5.608 5.422z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M159.116 20.208h-17.109c-7.223 0-13.082 5.664-13.082 12.65v16.544c0 6.986 5.859 12.65 13.082 12.65h17.109c7.226 0 13.083-5.664 13.083-12.65V32.858c0-6.986-5.857-12.65-13.083-12.65m6.901 26.83c0 4.99-4.183 9.035-9.345 9.035h-12.22c-5.16 0-9.345-4.045-9.345-9.035V35.222c0-4.99 4.185-9.035 9.345-9.035h12.22c5.162 0 9.345 4.046 9.345 9.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A310",
    d: "M159.835 44.675c0 2.994-2.51 5.421-5.605 5.421h-7.333c-3.097 0-5.608-2.427-5.608-5.421v-7.09c0-2.994 2.511-5.421 5.608-5.421h7.333c3.095 0 5.605 2.427 5.605 5.422z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00324C",
    d: "M47.843 127.805H30.734c-7.226 0-13.083 5.664-13.083 12.65v16.542c0 6.986 5.857 12.65 13.083 12.65h17.109c7.225 0 13.082-5.664 13.082-12.65v-16.542c0-6.986-5.856-12.65-13.082-12.65m6.9 26.828c0 4.992-4.184 9.037-9.345 9.037h-12.22c-5.16 0-9.345-4.045-9.345-9.037v-11.814c0-4.992 4.185-9.037 9.346-9.037h12.22c5.16 0 9.344 4.045 9.344 9.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A310",
    d: "M48.562 152.272c0 2.994-2.51 5.419-5.608 5.419h-7.33c-3.098 0-5.608-2.425-5.608-5.419v-7.092c0-2.994 2.51-5.421 5.607-5.421h7.331c3.097 0 5.608 2.427 5.608 5.421z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M182.001 27.556c0-10.795-8.763-19.555-19.555-19.555H27.556C16.763 8 8.002 16.76 8.002 27.556v134.889c0 10.793 8.76 19.556 19.556 19.556h134.889c10.792 0 19.555-8.763 19.555-19.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.736 139.748h-24.37v25.225h24.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.368 139.747h-9.635c-4.067 0-7.368 3.415-7.368 7.627v9.971c0 4.211 3.301 7.627 7.368 7.627h9.635c4.07 0 7.367-3.416 7.367-7.627v-9.971c0-4.212-3.298-7.627-7.367-7.627m3.885 16.175c0 3.008-2.354 5.445-5.262 5.445H33.11c-2.905 0-5.261-2.437-5.261-5.445V148.8c0-3.008 2.356-5.449 5.261-5.449h6.882c2.908 0 5.262 2.441 5.262 5.449z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D639",
    d: "M41.77 154.496c0 1.804-1.412 3.27-3.155 3.27h-4.13c-1.742 0-3.155-1.466-3.155-3.27v-4.274c0-1.804 1.413-3.266 3.156-3.266h4.129c1.743 0 3.155 1.462 3.155 3.266z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.88 25.048H24.77v24.186h24.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.59 25.046h-9.532c-4.023 0-7.288 3.275-7.288 7.313v9.56c0 4.039 3.265 7.313 7.288 7.313h9.533c4.026 0 7.288-3.274 7.288-7.312v-9.561c0-4.038-3.262-7.313-7.288-7.313m3.844 15.51c0 2.883-2.328 5.22-5.205 5.22H33.42c-2.874 0-5.205-2.337-5.205-5.22v-6.83c0-2.883 2.331-5.224 5.205-5.224h6.809c2.877 0 5.205 2.34 5.205 5.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D639",
    d: "M41.99 39.188a3.13 3.13 0 0 1-3.123 3.135h-4.085a3.13 3.13 0 0 1-3.122-3.135V35.09a3.127 3.127 0 0 1 3.122-3.132h4.085a3.127 3.127 0 0 1 3.122 3.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M164.585 24.528h-23.721v24.705h23.721z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M157.413 24.527h-9.379c-3.958 0-7.171 3.345-7.171 7.47v9.765c0 4.125 3.213 7.47 7.171 7.47h9.379c3.961 0 7.171-3.345 7.171-7.47v-9.766c0-4.124-3.21-7.47-7.171-7.47m3.781 15.842c0 2.946-2.291 5.333-5.121 5.333h-6.699c-2.827 0-5.121-2.387-5.121-5.333v-6.976c0-2.946 2.294-5.336 5.121-5.336h6.699c2.83 0 5.121 2.39 5.121 5.336z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D639",
    d: "M157.805 38.972c0 1.767-1.375 3.203-3.072 3.203h-4.019c-1.696 0-3.071-1.436-3.071-3.203v-4.186c0-1.767 1.375-3.199 3.071-3.199h4.019c1.697 0 3.072 1.432 3.072 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.862 24.964h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.281 24.964H58.76v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.702 24.964H62.18v3.472h3.522zM86.222 24.964h-3.523v3.472h3.523zM93.062 24.964h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M96.482 24.964h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 24.964h-3.523v3.472H99.9zM106.742 24.964h-3.522v3.472h3.522zM113.581 24.964h-3.522v3.472h3.522zM123.842 24.964h-3.523v3.472h3.523zM130.682 24.964h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M134.102 24.964h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 24.964h-3.523v3.472h3.523zM65.702 28.334H62.18v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M69.121 28.334H65.6v3.472h3.522zM79.382 28.334h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M82.802 28.334h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M86.222 28.334h-3.523v3.472h3.523zM96.482 28.334h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 28.334h-3.523v3.472H99.9zM113.581 28.334h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M117.002 28.334h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 28.334h-3.523v3.472h3.523zM130.682 28.334h-3.523v3.472h3.523zM137.522 28.334h-3.523v3.472h3.523zM55.442 31.705h-3.523v3.471h3.523zM65.702 31.705H62.18v3.471h3.522zM72.542 31.705H69.02v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.961 31.705H72.44v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.382 31.705h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M82.802 31.705h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M86.222 31.705h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M89.642 31.705h-3.523v3.471h3.523zM96.482 31.705h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 31.705h-3.523v3.471H99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M103.321 31.705h-3.522v3.471h3.522zM113.581 31.705h-3.522v3.471h3.522zM123.842 31.705h-3.523v3.471h3.523zM134.102 31.705h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 31.705h-3.523v3.471h3.523zM55.442 35.075h-3.523v3.471h3.523zM65.702 35.075H62.18v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M69.121 35.075H65.6v3.471h3.522zM79.382 35.075h-3.523v3.471h3.523zM96.482 35.075h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 35.075h-3.523v3.471H99.9zM106.742 35.075h-3.522v3.471h3.522zM117.002 35.075h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 35.075h-3.523v3.471h3.523zM130.682 35.075h-3.523v3.471h3.523zM55.442 38.445h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.862 38.445h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.281 38.445H58.76v3.471h3.522zM75.961 38.445H72.44v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.382 38.445h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M82.802 38.445h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M86.222 38.445h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M89.642 38.445h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M93.062 38.445h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M96.482 38.445h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 38.445h-3.523v3.471H99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M103.321 38.445h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M106.742 38.445h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M110.161 38.445h-3.522v3.471h3.522zM123.842 38.445h-3.523v3.471h3.523zM134.102 38.445h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 38.445h-3.523v3.471h3.523zM55.442 41.815h-3.523v3.472h3.523zM72.542 41.815H69.02v3.472h3.523zM79.382 41.815h-3.523v3.472h3.523zM86.222 41.815h-3.523v3.472h3.523zM99.902 41.815h-3.523v3.472H99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M103.321 41.815h-3.522v3.472h3.522zM110.161 41.815h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M113.581 41.815h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M117.002 41.815h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 41.815h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M123.842 41.815h-3.523v3.472h3.523zM130.682 41.815h-3.523v3.472h3.523zM137.522 41.815h-3.523v3.472h3.523zM55.442 45.186h-3.523v3.471h3.523zM62.281 45.186H58.76v3.471h3.522zM69.121 45.186H65.6v3.471h3.522zM75.961 45.186H72.44v3.471h3.522zM82.802 45.186h-3.523v3.471h3.523zM89.642 45.186h-3.523v3.471h3.523zM96.482 45.186h-3.523v3.471h3.523zM103.321 45.186h-3.522v3.471h3.522zM110.161 45.186h-3.522v3.471h3.522zM117.002 45.186h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M123.842 45.186h-3.523v3.471h3.523zM130.682 45.186h-3.523v3.471h3.523zM137.522 45.186h-3.523v3.471h3.523zM55.442 48.556h-3.523v3.471h3.523zM62.281 48.556H58.76v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.702 48.556H62.18v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M69.121 48.556H65.6v3.471h3.522zM79.382 48.556h-3.523v3.471h3.523zM93.062 48.556h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M96.482 48.556h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 48.556h-3.523v3.471H99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M103.321 48.556h-3.522v3.471h3.522zM117.002 48.556h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 48.556h-3.523v3.471h3.523zM130.682 48.556h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M134.102 48.556h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 48.556h-3.523v3.471h3.523zM28.081 51.926H24.56v3.472h3.522zM34.921 51.926h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M38.342 51.926h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.762 51.926h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M45.182 51.926h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.602 51.926h-3.523v3.472h3.523zM72.542 51.926H69.02v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.961 51.926H72.44v3.472h3.522zM86.222 51.926h-3.523v3.472h3.523zM93.062 51.926h-3.523v3.472h3.523zM110.161 51.926h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M113.581 51.926h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M117.002 51.926h-3.523v3.472h3.523zM127.262 51.926h-3.523v3.472h3.523zM134.102 51.926h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 51.926h-3.523v3.472h3.523zM144.361 51.926h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 51.926h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 51.926h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.621 51.926h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M158.042 51.926h-3.522v3.472h3.522zM28.081 55.297H24.56v3.471h3.522zM34.921 55.297h-3.523v3.471h3.523zM41.762 55.297h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M45.182 55.297h-3.523v3.471h3.523zM52.022 55.297h-3.523v3.471h3.523zM58.862 55.297h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.281 55.297H58.76v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.702 55.297H62.18v3.471h3.522zM79.382 55.297h-3.523v3.471h3.523zM93.062 55.297h-3.523v3.471h3.523zM106.742 55.297h-3.522v3.471h3.522zM113.581 55.297h-3.522v3.471h3.522zM123.842 55.297h-3.523v3.471h3.523zM130.682 55.297h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M134.102 55.297h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 55.297h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.942 55.297h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M144.361 55.297h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 55.297h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 55.297h-3.522v3.471h3.522zM158.042 55.297h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M161.462 55.297h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M164.882 55.297h-3.523v3.471h3.523zM31.501 58.667h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.921 58.667h-3.523v3.471h3.523zM41.762 58.667h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M45.182 58.667h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.602 58.667h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52.022 58.667h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M55.442 58.667h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.862 58.667h-3.523v3.471h3.523zM65.702 58.667H62.18v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M69.121 58.667H65.6v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M72.542 58.667H69.02v3.471h3.523zM82.802 58.667h-3.523v3.471h3.523zM96.482 58.667h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 58.667h-3.523v3.471H99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M103.321 58.667h-3.522v3.471h3.522zM110.161 58.667h-3.522v3.471h3.522zM117.002 58.667h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 58.667h-3.523v3.471h3.523zM137.522 58.667h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.942 58.667h-3.523v3.471h3.523zM147.781 58.667h-3.522v3.471h3.522zM28.081 62.037H24.56v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.501 62.037h-3.523v3.471h3.523zM41.762 62.037h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M45.182 62.037h-3.523v3.471h3.523zM52.022 62.037h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M55.442 62.037h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.862 62.037h-3.523v3.471h3.523zM72.542 62.037H69.02v3.471h3.523zM79.382 62.037h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M82.802 62.037h-3.523v3.471h3.523zM89.642 62.037h-3.523v3.471h3.523zM96.482 62.037h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 62.037h-3.523v3.471H99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M103.321 62.037h-3.522v3.471h3.522zM123.842 62.037h-3.523v3.471h3.523zM130.682 62.037h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M134.102 62.037h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 62.037h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.942 62.037h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M144.361 62.037h-3.522v3.471h3.522zM151.202 62.037h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.621 62.037h-3.522v3.471h3.522zM28.081 65.407H24.56v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.501 65.407h-3.523v3.472h3.523zM41.762 65.407h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M45.182 65.407h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.602 65.407h-3.523v3.472h3.523zM62.281 65.407H58.76v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.702 65.407H62.18v3.472h3.522zM82.802 65.407h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M86.222 65.407h-3.523v3.472h3.523zM93.062 65.407h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M96.482 65.407h-3.523v3.472h3.523zM103.321 65.407h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M106.742 65.407h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M110.161 65.407h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M113.581 65.407h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M117.002 65.407h-3.523v3.472h3.523zM123.842 65.407h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M127.262 65.407h-3.523v3.472h3.523zM134.102 65.407h-3.523v3.472h3.523zM147.781 65.407h-3.522v3.472h3.522zM154.621 65.407h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M158.042 65.407h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M161.462 65.407h-3.523v3.472h3.523zM28.081 68.778H24.56v3.471h3.522zM38.342 68.778h-3.523v3.471h3.523zM45.182 68.778h-3.523v3.471h3.523zM58.862 68.778h-3.523v3.471h3.523zM65.702 68.778H62.18v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M69.121 68.778H65.6v3.471h3.522zM75.961 68.778H72.44v3.471h3.522zM99.902 68.778h-3.523v3.471H99.9zM113.581 68.778h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M117.002 68.778h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 68.778h-3.523v3.471h3.523zM130.682 68.778h-3.523v3.471h3.523zM137.522 68.778h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.942 68.778h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M144.361 68.778h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 68.778h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 68.778h-3.522v3.471h3.522zM161.462 68.778h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M164.882 68.778h-3.523v3.471h3.523zM31.501 72.148h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.921 72.148h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M38.342 72.148h-3.523v3.471h3.523zM45.182 72.148h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.602 72.148h-3.523v3.471h3.523zM58.862 72.148h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.281 72.148H58.76v3.471h3.522zM69.121 72.148H65.6v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M72.542 72.148H69.02v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.961 72.148H72.44v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.382 72.148h-3.523v3.471h3.523zM86.222 72.148h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M89.642 72.148h-3.523v3.471h3.523zM96.482 72.148h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 72.148h-3.523v3.471H99.9zM106.742 72.148h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M110.161 72.148h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M113.581 72.148h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M117.002 72.148h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 72.148h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M123.842 72.148h-3.523v3.471h3.523zM130.682 72.148h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M134.102 72.148h-3.523v3.471h3.523zM140.942 72.148h-3.523v3.471h3.523zM147.781 72.148h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 72.148h-3.522v3.471h3.522zM158.042 72.148h-3.522v3.471h3.522zM28.081 75.518H24.56v3.471h3.522zM34.921 75.518h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M38.342 75.518h-3.523v3.471h3.523zM45.182 75.518h-3.523v3.471h3.523zM52.022 75.518h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M55.442 75.518h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.862 75.518h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.281 75.518H58.76v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.702 75.518H62.18v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M69.121 75.518H65.6v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M72.542 75.518H69.02v3.471h3.523zM82.802 75.518h-3.523v3.471h3.523zM89.642 75.518h-3.523v3.471h3.523zM99.902 75.518h-3.523v3.471H99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M103.321 75.518h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M106.742 75.518h-3.522v3.471h3.522zM117.002 75.518h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 75.518h-3.523v3.471h3.523zM134.102 75.518h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 75.518h-3.523v3.471h3.523zM144.361 75.518h-3.522v3.471h3.522zM151.202 75.518h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.621 75.518h-3.522v3.471h3.522zM161.462 75.518h-3.523v3.471h3.523zM31.501 78.888h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.921 78.888h-3.523v3.472h3.523zM41.762 78.888h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M45.182 78.888h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.602 78.888h-3.523v3.472h3.523zM55.442 78.888h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.862 78.888h-3.523v3.472h3.523zM75.961 78.888H72.44v3.472h3.522zM86.222 78.888h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M89.642 78.888h-3.523v3.472h3.523zM103.321 78.888h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M106.742 78.888h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M110.161 78.888h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M113.581 78.888h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M117.002 78.888h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 78.888h-3.523v3.472h3.523zM127.262 78.888h-3.523v3.472h3.523zM134.102 78.888h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 78.888h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.942 78.888h-3.523v3.472h3.523zM147.781 78.888h-3.522v3.472h3.522zM158.042 78.888h-3.522v3.472h3.522zM28.081 82.259H24.56v3.471h3.522zM34.921 82.259h-3.523v3.471h3.523zM58.862 82.259h-3.523v3.471h3.523zM65.702 82.259H62.18v3.471h3.522zM72.542 82.259H69.02v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.961 82.259H72.44v3.471h3.522zM82.802 82.259h-3.523v3.471h3.523zM89.642 82.259h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M93.062 82.259h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M96.482 82.259h-3.523v3.471h3.523zM106.742 82.259h-3.522v3.471h3.522zM117.002 82.259h-3.523v3.471h3.523zM123.842 82.259h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M127.262 82.259h-3.523v3.471h3.523zM134.102 82.259h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 82.259h-3.523v3.471h3.523zM144.361 82.259h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 82.259h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 82.259h-3.522v3.471h3.522zM158.042 82.259h-3.522v3.471h3.522zM164.882 82.259h-3.523v3.471h3.523zM28.081 85.629H24.56V89.1h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.501 85.629h-3.523V89.1h3.523zM38.342 85.629h-3.523V89.1h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.762 85.629h-3.523V89.1h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M45.182 85.629h-3.523V89.1h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.602 85.629h-3.523V89.1h3.523zM58.862 85.629h-3.523V89.1h3.523zM69.121 85.629H65.6V89.1h3.522zM75.961 85.629H72.44V89.1h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.382 85.629h-3.523V89.1h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M82.802 85.629h-3.523V89.1h3.523zM89.642 85.629h-3.523V89.1h3.523zM96.482 85.629h-3.523V89.1h3.523zM103.321 85.629h-3.522V89.1h3.522zM120.421 85.629h-3.523V89.1h3.523zM127.262 85.629h-3.523V89.1h3.523zM140.942 85.629h-3.523V89.1h3.523zM151.202 85.629h-3.522V89.1h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.621 85.629h-3.522V89.1h3.522zM38.342 88.999h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.762 88.999h-3.523v3.471h3.523zM55.442 88.999h-3.523v3.471h3.523zM69.121 88.999H65.6v3.471h3.522zM82.802 88.999h-3.523v3.471h3.523zM93.062 88.999h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M96.482 88.999h-3.523v3.471h3.523zM117.002 88.999h-3.523v3.471h3.523zM123.842 88.999h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M127.262 88.999h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M130.682 88.999h-3.523v3.471h3.523zM137.522 88.999h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.942 88.999h-3.523v3.471h3.523zM151.202 88.999h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.621 88.999h-3.522v3.471h3.522zM164.882 88.999h-3.523v3.471h3.523zM28.081 92.37H24.56v3.47h3.522zM34.921 92.37h-3.523v3.47h3.523zM41.762 92.37h-3.523v3.47h3.523zM48.602 92.37h-3.523v3.47h3.523zM58.862 92.37h-3.523v3.47h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.281 92.37H58.76v3.47h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.702 92.37H62.18v3.47h3.522zM75.961 92.37H72.44v3.47h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.382 92.37h-3.523v3.47h3.523zM89.642 92.37h-3.523v3.47h3.523zM99.902 92.37h-3.523v3.47H99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M103.321 92.37h-3.522v3.47h3.522zM110.161 92.37h-3.522v3.47h3.522zM147.781 92.37h-3.522v3.47h3.522zM154.621 92.37h-3.522v3.47h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M158.042 92.37h-3.522v3.47h3.522zM164.882 92.37h-3.523v3.47h3.523zM38.342 95.74h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.762 95.74h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M45.182 95.74h-3.523v3.471h3.523zM55.442 95.74h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.862 95.74h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.281 95.74H58.76v3.471h3.522zM69.121 95.74H65.6v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M72.542 95.74H69.02v3.471h3.523zM79.382 95.74h-3.523v3.471h3.523zM93.062 95.74h-3.523v3.471h3.523zM106.742 95.74h-3.522v3.471h3.522zM113.581 95.74h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M117.002 95.74h-3.523v3.471h3.523zM123.842 95.74h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M127.262 95.74h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M130.682 95.74h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M134.102 95.74h-3.523v3.471h3.523zM144.361 95.74h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 95.74h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 95.74h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.621 95.74h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M158.042 95.74h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M161.462 95.74h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M164.882 95.74h-3.523v3.471h3.523zM28.081 99.11H24.56v3.471h3.522zM34.921 99.11h-3.523v3.471h3.523zM41.762 99.11h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M45.182 99.11h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.602 99.11h-3.523v3.471h3.523zM62.281 99.11H58.76v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.702 99.11H62.18v3.471h3.522zM86.222 99.11h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M89.642 99.11h-3.523v3.471h3.523zM96.482 99.11h-3.523v3.471h3.523zM103.321 99.11h-3.522v3.471h3.522zM113.581 99.11h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M117.002 99.11h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 99.11h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M123.842 99.11h-3.523v3.471h3.523zM137.522 99.11h-3.523v3.471h3.523zM144.361 99.11h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 99.11h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 99.11h-3.522v3.471h3.522zM31.501 102.48h-3.523v3.472h3.523zM38.342 102.48h-3.523v3.472h3.523zM45.182 102.48h-3.523v3.472h3.523zM52.022 102.48h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M55.442 102.48h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.862 102.48h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.281 102.48H58.76v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.702 102.48H62.18v3.472h3.522zM72.542 102.48H69.02v3.472h3.523zM79.382 102.48h-3.523v3.472h3.523zM96.482 102.48h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 102.48h-3.523v3.472H99.9zM110.161 102.48h-3.522v3.472h3.522zM117.002 102.48h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 102.48h-3.523v3.472h3.523zM130.682 102.48h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M134.102 102.48h-3.523v3.472h3.523zM144.361 102.48h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 102.48h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 102.48h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.621 102.48h-3.522v3.472h3.522zM164.882 102.48h-3.523v3.472h3.523zM28.081 105.85H24.56v3.472h3.522zM38.342 105.85h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.762 105.85h-3.523v3.472h3.523zM48.602 105.85h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52.022 105.85h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M55.442 105.85h-3.523v3.472h3.523zM65.702 105.85H62.18v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M69.121 105.85H65.6v3.472h3.522zM79.382 105.85h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M82.802 105.85h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M86.222 105.85h-3.523v3.472h3.523zM93.062 105.85h-3.523v3.472h3.523zM103.321 105.85h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M106.742 105.85h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M110.161 105.85h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M113.581 105.85h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M117.002 105.85h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 105.85h-3.523v3.472h3.523zM127.262 105.85h-3.523v3.472h3.523zM147.781 105.85h-3.522v3.472h3.522zM158.042 105.85h-3.522v3.472h3.522zM28.081 109.221H24.56v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.501 109.221h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.921 109.221h-3.523v3.471h3.523zM45.182 109.221h-3.523v3.471h3.523zM52.022 109.221h-3.523v3.471h3.523zM58.862 109.221h-3.523v3.471h3.523zM65.702 109.221H62.18v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M69.121 109.221H65.6v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M72.542 109.221H69.02v3.471h3.523zM82.802 109.221h-3.523v3.471h3.523zM93.062 109.221h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M96.482 109.221h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 109.221h-3.523v3.471H99.9zM106.742 109.221h-3.522v3.471h3.522zM130.682 109.221h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M134.102 109.221h-3.523v3.471h3.523zM140.942 109.221h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M144.361 109.221h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 109.221h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 109.221h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.621 109.221h-3.522v3.471h3.522zM161.462 109.221h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M164.882 109.221h-3.523v3.471h3.523zM28.081 112.591H24.56v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.501 112.591h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.921 112.591h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M38.342 112.591h-3.523v3.471h3.523zM48.602 112.591h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52.022 112.591h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M55.442 112.591h-3.523v3.471h3.523zM65.702 112.591H62.18v3.471h3.522zM82.802 112.591h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M86.222 112.591h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M89.642 112.591h-3.523v3.471h3.523zM96.482 112.591h-3.523v3.471h3.523zM113.581 112.591h-3.522v3.471h3.522zM120.421 112.591h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M123.842 112.591h-3.523v3.471h3.523zM137.522 112.591h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.942 112.591h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M144.361 112.591h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 112.591h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 112.591h-3.522v3.471h3.522zM28.081 115.961H24.56v3.472h3.522zM34.921 115.961h-3.523v3.472h3.523zM55.442 115.961h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.862 115.961h-3.523v3.472h3.523zM65.702 115.961H62.18v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M69.121 115.961H65.6v3.472h3.522zM75.961 115.961H72.44v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.382 115.961h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M82.802 115.961h-3.523v3.472h3.523zM89.642 115.961h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M93.062 115.961h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M96.482 115.961h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 115.961h-3.523v3.472H99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M103.321 115.961h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M106.742 115.961h-3.522v3.472h3.522zM117.002 115.961h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 115.961h-3.523v3.472h3.523zM134.102 115.961h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 115.961h-3.523v3.472h3.523zM147.781 115.961h-3.522v3.472h3.522zM154.621 115.961h-3.522v3.472h3.522zM164.882 115.961h-3.523v3.472h3.523zM28.081 119.331H24.56v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.501 119.331h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.921 119.331h-3.523v3.472h3.523zM48.602 119.331h-3.523v3.472h3.523zM55.442 119.331h-3.523v3.472h3.523zM62.281 119.331H58.76v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.702 119.331H62.18v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M69.121 119.331H65.6v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M72.542 119.331H69.02v3.472h3.523zM82.802 119.331h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M86.222 119.331h-3.523v3.472h3.523zM93.062 119.331h-3.523v3.472h3.523zM103.321 119.331h-3.522v3.472h3.522zM113.581 119.331h-3.522v3.472h3.522zM127.262 119.331h-3.523v3.472h3.523zM134.102 119.331h-3.523v3.472h3.523zM154.621 119.331h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M158.042 119.331h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M161.462 119.331h-3.523v3.472h3.523zM28.081 122.701H24.56v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.501 122.701h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.921 122.701h-3.523v3.472h3.523zM41.762 122.701h-3.523v3.472h3.523zM52.022 122.701h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M55.442 122.701h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.862 122.701h-3.523v3.472h3.523zM69.121 122.701H65.6v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M72.542 122.701H69.02v3.472h3.523zM79.382 122.701h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M82.802 122.701h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M86.222 122.701h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M89.642 122.701h-3.523v3.472h3.523zM96.482 122.701h-3.523v3.472h3.523zM110.161 122.701h-3.522v3.472h3.522zM117.002 122.701h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 122.701h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M123.842 122.701h-3.523v3.472h3.523zM140.942 122.701h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M144.361 122.701h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 122.701h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 122.701h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.621 122.701h-3.522v3.472h3.522zM164.882 122.701h-3.523v3.472h3.523zM28.081 126.072H24.56v3.471h3.522zM48.602 126.072h-3.523v3.471h3.523zM55.442 126.072h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.862 126.072h-3.523v3.471h3.523zM65.702 126.072H62.18v3.471h3.522zM72.542 126.072H69.02v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.961 126.072H72.44v3.471h3.522zM82.802 126.072h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M86.222 126.072h-3.523v3.471h3.523zM93.062 126.072h-3.523v3.471h3.523zM103.321 126.072h-3.522v3.471h3.522zM113.581 126.072h-3.522v3.471h3.522zM127.262 126.072h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M130.682 126.072h-3.523v3.471h3.523zM140.942 126.072h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M144.361 126.072h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 126.072h-3.522v3.471h3.522zM154.621 126.072h-3.522v3.471h3.522zM28.081 129.442H24.56v3.472h3.522zM34.921 129.442h-3.523v3.472h3.523zM41.762 129.442h-3.523v3.472h3.523zM55.442 129.442h-3.523v3.472h3.523zM62.281 129.442H58.76v3.472h3.522zM75.961 129.442H72.44v3.472h3.522zM89.642 129.442h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M93.062 129.442h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M96.482 129.442h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 129.442h-3.523v3.472H99.9zM110.161 129.442h-3.522v3.472h3.522zM123.842 129.442h-3.523v3.472h3.523zM130.682 129.442h-3.523v3.472h3.523zM137.522 129.442h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.942 129.442h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M144.361 129.442h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 129.442h-3.522v3.472h3.522zM28.081 132.812H24.56v3.472h3.522zM34.921 132.812h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M38.342 132.812h-3.523v3.472h3.523zM48.602 132.812h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52.022 132.812h-3.523v3.472h3.523zM58.862 132.812h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.281 132.812H58.76v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.702 132.812H62.18v3.472h3.522zM72.542 132.812H69.02v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.961 132.812H72.44v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.382 132.812h-3.523v3.472h3.523zM86.222 132.812h-3.523v3.472h3.523zM93.062 132.812h-3.523v3.472h3.523zM103.321 132.812h-3.522v3.472h3.522zM110.161 132.812h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M113.581 132.812h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M117.002 132.812h-3.523v3.472h3.523zM127.262 132.812h-3.523v3.472h3.523zM137.522 132.812h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.942 132.812h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M144.361 132.812h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 132.812h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 132.812h-3.522v3.472h3.522zM158.042 132.812h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M161.462 132.812h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M164.882 132.812h-3.523v3.472h3.523zM55.442 136.183h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.862 136.183h-3.523v3.471h3.523zM65.702 136.183H62.18v3.471h3.522zM79.382 136.183h-3.523v3.471h3.523zM86.222 136.183h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M89.642 136.183h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M93.062 136.183h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M96.482 136.183h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 136.183h-3.523v3.471H99.9zM106.742 136.183h-3.522v3.471h3.522zM113.581 136.183h-3.522v3.471h3.522zM130.682 136.183h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M134.102 136.183h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 136.183h-3.523v3.471h3.523zM151.202 136.183h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.621 136.183h-3.522v3.471h3.522zM161.462 136.183h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M164.882 136.183h-3.523v3.471h3.523zM75.961 139.553H72.44v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.382 139.553h-3.523v3.471h3.523zM86.222 139.553h-3.523v3.471h3.523zM96.482 139.553h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 139.553h-3.523v3.471H99.9zM113.581 139.553h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M117.002 139.553h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 139.553h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M123.842 139.553h-3.523v3.471h3.523zM130.682 139.553h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M134.102 139.553h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 139.553h-3.523v3.471h3.523zM144.361 139.553h-3.522v3.471h3.522zM151.202 139.553h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.621 139.553h-3.522v3.471h3.522zM55.442 142.923h-3.523v3.472h3.523zM75.961 142.923H72.44v3.472h3.522zM82.802 142.923h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M86.222 142.923h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M89.642 142.923h-3.523v3.472h3.523zM99.902 142.923h-3.523v3.472H99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M103.321 142.923h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M106.742 142.923h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M110.161 142.923h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M113.581 142.923h-3.522v3.472h3.522zM120.421 142.923h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M123.842 142.923h-3.523v3.472h3.523zM134.102 142.923h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 142.923h-3.523v3.472h3.523zM151.202 142.923h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.621 142.923h-3.522v3.472h3.522zM161.462 142.923h-3.523v3.472h3.523zM55.442 146.294h-3.523v3.471h3.523zM62.281 146.294H58.76v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.702 146.294H62.18v3.471h3.522zM75.961 146.294H72.44v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.382 146.294h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M82.802 146.294h-3.523v3.471h3.523zM99.902 146.294h-3.523v3.471H99.9zM110.161 146.294h-3.522v3.471h3.522zM117.002 146.294h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 146.294h-3.523v3.471h3.523zM130.682 146.294h-3.523v3.471h3.523zM137.522 146.294h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.942 146.294h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M144.361 146.294h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 146.294h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 146.294h-3.522v3.471h3.522zM158.042 146.294h-3.522v3.471h3.522zM55.442 149.664h-3.523v3.471h3.523zM75.961 149.664H72.44v3.471h3.522zM82.802 149.664h-3.523v3.471h3.523zM89.642 149.664h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M93.062 149.664h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M96.482 149.664h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 149.664h-3.523v3.471H99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M103.321 149.664h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M106.742 149.664h-3.522v3.471h3.522zM113.581 149.664h-3.522v3.471h3.522zM123.842 149.664h-3.523v3.471h3.523zM137.522 149.664h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.942 149.664h-3.523v3.471h3.523zM147.781 149.664h-3.522v3.471h3.522zM154.621 149.664h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M158.042 149.664h-3.522v3.471h3.522zM55.442 153.034h-3.523v3.471h3.523zM69.121 153.034H65.6v3.471h3.522zM79.382 153.034h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M82.802 153.034h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M86.222 153.034h-3.523v3.471h3.523zM96.482 153.034h-3.523v3.471h3.523zM113.581 153.034h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M117.002 153.034h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 153.034h-3.523v3.471h3.523zM130.682 153.034h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M134.102 153.034h-3.523v3.471h3.523zM140.942 153.034h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M144.361 153.034h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.781 153.034h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 153.034h-3.522v3.471h3.522zM72.542 156.404H69.02v3.472h3.523zM82.802 156.404h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M86.222 156.404h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M89.642 156.404h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M93.062 156.404h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M96.482 156.404h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M99.902 156.404h-3.523v3.472H99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M103.321 156.404h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M106.742 156.404h-3.522v3.472h3.522zM117.002 156.404h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 156.404h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M123.842 156.404h-3.523v3.472h3.523zM134.102 156.404h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M137.522 156.404h-3.523v3.472h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.942 156.404h-3.523v3.472h3.523zM151.202 156.404h-3.522v3.472h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.621 156.404h-3.522v3.472h3.522zM161.462 156.404h-3.523v3.472h3.523zM55.442 159.775h-3.523v3.471h3.523zM72.542 159.775H69.02v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.961 159.775H72.44v3.471h3.522zM86.222 159.775h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M89.642 159.775h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M93.062 159.775h-3.523v3.471h3.523zM103.321 159.775h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M106.742 159.775h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M110.161 159.775h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M113.581 159.775h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M117.002 159.775h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.421 159.775h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M123.842 159.775h-3.523v3.471h3.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M127.262 159.775h-3.523v3.471h3.523zM134.102 159.775h-3.523v3.471h3.523zM140.942 159.775h-3.523v3.471h3.523zM147.781 159.775h-3.522v3.471h3.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.202 159.775h-3.522v3.471h3.522zM158.042 159.775h-3.522v3.471h3.522z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CallerTrackerAndroid_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h189.2v220H0z"
  })))));
};
export default SvgCallerTrackerAndroid;